{
  "version": 1,
  "asset_id": "2fa2db38-317d-4efe-b3ec-d921f681c41b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/2fa2db38-317d-4efe-b3ec-d921f681c41b/metal-roof-installation-citrus-county-fl-1600.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/2fa2db38-317d-4efe-b3ec-d921f681c41b/metal-roof-installation-citrus-county-fl-1600.webp",
  "original_filename": "metal-roof-installation-citrus-county-fl-1600.webp",
  "size": 142646,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:32Z"
}
